import { createSelector } from 'reselect';
import { get, isEmpty, compose, keys } from 'lodash/fp';
import { getStringProp } from '@mews/fp';
import { getAvailabilityBlock } from '@mews-commander/legacy-entities/src/ducks/availabilityBlocks';
import { getRates } from '@mews-commander/legacy-entities/src/ducks/rates';
import { moduleSelector } from '../module';

export const getMatrixRateGroups = createSelector(
    moduleSelector,
    getStringProp('scope'),
    (state, scope) => state.rateGroups[scope] || {}
);

const getRateGroupIdFromProps = getStringProp('rateGroupId');

export const areRateGroupsEmpty = createSelector(getMatrixRateGroups, isEmpty);

export const getMobileRateGroupId = compose(get('mobileRateGroupId'), getMatrixRateGroups);

const getRateGroup = (getRateGroupId: $TSFixMe) =>
    // @ts-expect-error $TSFixMeError: Type 'unknown' cannot be used as an index type.
    createSelector(getMatrixRateGroups, getRateGroupId, (rateGroups, rateGroupId) => rateGroups[rateGroupId]);

const getDesktopRateGroup = getRateGroup(getRateGroupIdFromProps);
const getMobileRateGroup = getRateGroup(getMobileRateGroupId);

const getRateIdByRateGroup = (getTypeOfRateGroup: $TSFixMe) =>
    createSelector(
        getTypeOfRateGroup,
        (rateGroup) => get('selectedRateId', rateGroup) || get('defaultRateId', rateGroup)
    );

export const getRateId = getRateIdByRateGroup(getDesktopRateGroup);

export const getMobileRateId = getRateIdByRateGroup(getMobileRateGroup);

export const getStoredAvailableRateGroupIds = createSelector(getMatrixRateGroups, keys);

export const getRateGroupIdFromAvailabilityBlockId = createSelector(
    getAvailabilityBlock,
    getRates,
    (availabilityBlock, rates) => {
        const rate = availabilityBlock && get(availabilityBlock.rateId, rates);
        return rate ? get('rateGroupId', rate) : null;
    }
);
